/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { DataLockLevel } from '../models/data-lock-level';
import { Regarding } from '../models/regarding';
import { SourceSystem } from '../models/source-system';
export interface IdentityMap {
  dataLockLevel?: DataLockLevel;

  /**
   * A unique reference for this identity map record
   */
  id?: string | null;

  /**
   * External identity
   */
  identity?: string | null;

  /**
   * Is the record locked by the other system
   */
  isLocked?: boolean;

  /**
   * Is this identitymap the primary identitymap for the entity
   */
  isPrimary?: boolean;
  source?: SourceSystem;
  target?: Regarding;

  /**
   * Version of the record in the source system
   */
  version?: string | null;
}

export class IdentityMap {
  dataLockLevel?: DataLockLevel;
  id?: string | null;
  identity?: string | null;
  isLocked?: boolean;
  isPrimary?: boolean;
  source?: SourceSystem;
  target?: Regarding;
  version?: string | null;

  constructor(value: IdentityMap) {
    this.dataLockLevel = value?.dataLockLevel ? Object.entries(Object.values(DataLockLevel)).flatMap((x) => x).find(x => x === value.dataLockLevel) as DataLockLevel : undefined;
    this.id = value?.id;
    this.identity = value?.identity;
    this.isLocked = value?.isLocked;
    this.isPrimary = value?.isPrimary;
    this.source = value?.source ? new SourceSystem(value.source) : undefined;
    this.target = value?.target ? new Regarding(value.target) : undefined;
    this.version = value?.version;
  }
}
